import {
    OperationTypeSelectedEvent,
    PropertyTypeSelectedEvent,
    SearchButtonClickedEvent,
    UserSearchRenderedEvent,
    UserSearchSubmittedEvent
} from "./events";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {WhitelabelEvent} from "../../../../common/ts/events/Events";
import location from "../../../../common/ts/core/location";
import dom from "../../../../common/ts/core/dom";
import tracking from "../../../../common/ts/core/tracking";
import {paidParamsFrom} from "../../serp/paidParamsFrom";
import {retentionParamsFrom} from "../../serp/retentionParamsFrom";
import {FiltersSubmittedEvent} from "../../serp/filters/events";
import {navigateToUserSearchWith} from "../../navigateToUserSearchWith";

let eventBus: EventBus;

const SEARCH_URL_SEPARATOR = "-";

export function userSearchRenderedEventHandler(event: WhitelabelEvent) {
    const {payload: {selector, inputName, text},} = event as UserSearchRenderedEvent;
    eventBus.emit(new dom.PopulateFormEvent({
        selector: selector,
        data: [[inputName, text]]
    }))
}

export function userSearchSubmittedEventHandler(event: WhitelabelEvent) {
    const {payload: {host, search = '', searchParams}} = event as UserSearchSubmittedEvent;

    const retentionParamsKept = retentionParamsFrom(searchParams);
    const searchParamsKept = paidParamsFrom(searchParams);
    const combinedParams = new URLSearchParams({
        ...Object.fromEntries(retentionParamsKept),
        ...Object.fromEntries(searchParamsKept)
    });

    eventBus.emit(navigateToUserSearchWith(host, combinedParams));
}

export function searchButtonClickedEventHandler(event: WhitelabelEvent) {
    eventBus.emit(new tracking.TrackAnalyticsEvent({
        name: 'serp-search-bar-search-button'
    }))
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(UserSearchRenderedEvent.TYPE, userSearchRenderedEventHandler);
    eventBus.subscribe(UserSearchSubmittedEvent.TYPE, userSearchSubmittedEventHandler)
    eventBus.subscribe(SearchButtonClickedEvent.TYPE, searchButtonClickedEventHandler);
    eventBus.subscribe(OperationTypeSelectedEvent.TYPE, operationTypeChangedEventHandler);
    eventBus.subscribe(PropertyTypeSelectedEvent.TYPE, propertyTypeChangedEventHandler);
}

function searchTermToPathname(search: string) {
    return search?.trim().replace(/ /g, SEARCH_URL_SEPARATOR);
}

export default {
    init
};

const OPERATION_TYPE_CHANGED_TRACKING_EVENT_NAME = 'serp-search-bar-offer-type';

function mergeSearchParams(searchParams: URLSearchParams): URLSearchParams {
    const retentionParams = retentionParamsFrom(searchParams);
    const paidParams = paidParamsFrom(searchParams);
    const combinedParams = new URLSearchParams();

    const appendParams = (params: URLSearchParams) => {
        for (const [key, value] of params) {
            combinedParams.set(key, value);
        }
    };

    appendParams(searchParams);
    appendParams(retentionParams);
    appendParams(paidParams);

    return combinedParams;
}

export function operationTypeChangedEventHandler(event: WhitelabelEvent) {
    const {payload: {name, value, isModalOpen, formData, searchParams}} = (event as OperationTypeSelectedEvent);

    if (isModalOpen) {
        return;
    }

    const urlSearchParams = mergeSearchParams(searchParams);
    eventBus.emitMany([
        new tracking.TrackAnalyticsEvent({name: OPERATION_TYPE_CHANGED_TRACKING_EVENT_NAME}),
        new FiltersSubmittedEvent({
            formData: {...formData, [name]: value},
            searchParams: urlSearchParams,
            type: FiltersSubmittedEvent.FORM_TYPE,
        }),
        new tracking.TrackWebTrackingEvent({
            type: "FiltersUpdated",
            serpUrl: window.location.href,
            filters: { operationType: value },
        }),
    ]);
}

export function propertyTypeChangedEventHandler(event: WhitelabelEvent) {
    const {payload: {name, value, formData, searchParams}} = (event as PropertyTypeSelectedEvent);

    const urlSearchParams = mergeSearchParams(searchParams);
    eventBus.emitMany([
        new FiltersSubmittedEvent({
            formData: {...formData, [name]: value},
            searchParams: urlSearchParams,
            type: FiltersSubmittedEvent.FORM_TYPE,
        }),
        new tracking.TrackWebTrackingEvent({
            type: "FiltersUpdated",
            serpUrl: window.location.href,
            filters: { operationType: value },
        }),
    ]);
}
